import { __assign, __rest } from "tslib";
import React from 'react';
import { PositionerAbsolute, PositionerFixed, PositionerRelative, } from '../styled/Modal';
var Positioner = function Positioner(_a) {
    var scrollBehavior = _a.scrollBehavior, props = __rest(_a, ["scrollBehavior"]);
    // default 'inside'
    var PositionComponent = PositionerAbsolute;
    if (scrollBehavior === 'outside') {
        PositionComponent = PositionerRelative;
    }
    else if (scrollBehavior === 'inside-wide') {
        PositionComponent = PositionerFixed;
    }
    return React.createElement(PositionComponent, __assign({}, props));
};
export default Positioner;
//# sourceMappingURL=Positioner.js.map